export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8537.768daf42.jpg";